import { AbstractCollapsable } from '../../types/lux/ui'

export default AbstractCollapsable

/** @constructor @extends {AbstractCollapsable} @suppress {checkTypes} */ function _Collapsable() {}
AbstractCollapsable.__implement(
  _Collapsable.prototype = /** @type {!AbstractCollapsable} */ ({
    collapse() {
      const {
        asIElemental:{element},
        asIStateful: { setState },
        state: { collapsed, collapsing, uncollapsing },
      } = this
      if (collapsed || collapsing || uncollapsing) return
      setState({ collapsing: true })
      collapse(element, {
        cbb: () => {
          setState({ collapsing: false, collapsed: true })
        },
      })
    },
    uncollapse() {
      const {
        asIElemental:{element},
        asIStateful: { setState },
        state: { collapsed, collapsing, uncollapsing },
      } = this
      if (!collapsed || uncollapsing || collapsing) return
      setState({ uncollapsing: true })
      uncollapse(element, {
        cbb: () => {
          setState({ uncollapsing: false, collapsed: false })
        },
      })
    },
  }),
)

/**
 * @param {HTMLElement} el
 */
export const collapse = (el, { cbb, step = 5 } = {}) => {
  const { scrollHeight, style } = el
  let h = scrollHeight
  if (h == 0) return
  style.overflow = 'hidden'

  const cb = () => {
    if (h > 0) {
      h -= step
      style.height = `${h}px`
      requestAnimationFrame(cb)
    } else {
      cancelAnimationFrame(frames)
      style.height = '0px'
      if (cbb) cbb()
    }
  }
  const frames = requestAnimationFrame(cb)
}


/**
 * @param {HTMLElement} el
 */
export const uncollapse = (el, { cbb } = {}) => {
  const { scrollHeight, style } = el
  let h = 0
  const cb = () => {
    if (h < scrollHeight) {
      h += 5
      style.height = `${h}px`
      requestAnimationFrame(cb)
    } else {
      cancelAnimationFrame(frames)
      style.height = ''
      style.overflow = ''
      if (cbb) cbb()
    }
  }
  const frames = requestAnimationFrame(cb)
}